import { isOneTimePrice } from "@/react/helpers/paywallPriceHelpers";
import type {
  Paywall,
  PaywallCheckoutPreview,
  PaywallPrice,
} from "@circle-react/types";

export const getPaywallPrice = (
  paywall: Paywall,
  priceId?: number,
): PaywallPrice => {
  let price: PaywallPrice | undefined;
  if (priceId) {
    price = paywall.prices.find(price => price.id === priceId);
  }
  if (!price) {
    const preferredPrice = paywall.prices.find(price => price.preferred);
    if (preferredPrice) {
      price = preferredPrice;
    } else {
      price = paywall.prices[0];
    }
  }
  return price;
};

export const getPaywallPriceAmount = (
  price: PaywallPrice,
  preview?: PaywallCheckoutPreview,
) => {
  if (preview) {
    return preview.amount_due_now;
  }

  let amount: number = 0;
  if (isOneTimePrice(price)) {
    amount = price.amount;
  } else {
    amount = price.upfront_payment_amount || price.amount;
  }

  return amount;
};
